import React, { useEffect, useState } from 'react';
import axios from 'axios';


export default function ContactForm() {
  const [captcha, setCaptcha] = useState({ token: '', question: '' });
  const [form, setForm] = useState({
    name: '', email: '', phone: '', subject: '', message: '',
    hp: '', // honeypot: leave empty
    captchaToken: '',
    captchaAnswer: '',
    renderedAt: new Date().toISOString(),
  });

  useEffect(() => {
    axios.get('http://localhost:8000/api/captcha').then(({ data }) => {
      setCaptcha(data);
      setForm(f => ({ ...f, captchaToken: data.token }));
    });
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('http://localhost:8000/api/contact', form, { headers: { 'Content-Type': 'application/json' } });
      alert('Message sent!');
    } catch (err) {
      alert(err.response?.data?.error || 'Submission failed');
    }
  };

  const setField = (e) => setForm({ ...form, [e.target.name]: e.target.value });


  return (
    <form onSubmit={submit}>
      <div className="row">
        <div className="col-6">
          <div className="single-input">
            <label htmlFor="name">Nama</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="What's your name?"
              value={form.name} onChange={setField}
              required
            />
            {/* Honeypot: hide with CSS; ensure screen readers ignore */}
            <input
                name="hp"
                value={form.hp}
                onChange={setField}
                aria-hidden="true"
                tabIndex={-1}
                style={{ position: 'absolute', left: '-9999px' }}
            />

          </div>
        </div>
        <div className="col-6">
          <div className="single-input">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              id="email"
              name="email"
              placeholder="What's your email?"
              value={form.email} onChange={setField}
              required
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="single-input">
            <label htmlFor="phone">Telp</label>
            <input
              type="text"
              id="phone"
              name="phone"
              placeholder="0852 8888 8888"
              value={form.phone} onChange={setField}
              required
            />
          </div>
        </div>
        <div className="col-6">
          <div className="single-input">
            <label htmlFor="loan">Subject</label>
            <input
              type="text"
              id="loan"
              name="subject"
              placeholder="Topik / Subject"
              value={form.subject} onChange={setField}
              required
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="single-input">
            <label htmlFor="message">Message / Pesan</label>
            <textarea
              id="message"
              name="message"
              placeholder="I would like to get in touch with you..."
              value={form.message} onChange={setField}
              cols="30"
              rows="10"
              required
            ></textarea>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="single-input">
            <label htmlFor="message">Solve: {captcha.question}</label>
            <input
                name="captchaAnswer"
                type="number"
                value={form.captchaAnswer}
                onChange={setField}
                required
            />

          </div>
        </div>
      </div>
      <div className="btn-area text-center">
        <button type="submit" className="cmn-btn">
          Send Message
        </button>
      </div>
    </form>
  );
};
